import { __awaiter, __extends, __generator, __read, __values } from "tslib";
import { HttpResponse } from "@aws-sdk/protocol-http";
import { buildQueryString } from "@aws-sdk/querystring-builder";
import { EventEmitter } from "events";
import { requestTimeout } from "./request-timeout";
var EVENTS = {
    get PROGRESS() {
        return "xhr.progress";
    },
    get UPLOAD_PROGRESS() {
        return "xhr.upload.progress";
    },
    get XHR_INSTANTIATED() {
        return "after.xhr.new";
    },
    get BEFORE_XHR_SEND() {
        return "before.xhr.send";
    },
};
var XhrHttpHandler = (function (_super) {
    __extends(XhrHttpHandler, _super);
    function XhrHttpHandler(options) {
        var _this = _super.call(this) || this;
        if (typeof options === "function") {
            _this.configProvider = options();
        }
        else {
            _this.config = options !== null && options !== void 0 ? options : {};
            _this.configProvider = Promise.resolve(_this.config);
        }
        return _this;
    }
    XhrHttpHandler.prototype.destroy = function () {
    };
    XhrHttpHandler.prototype.handle = function (request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        return __awaiter(this, void 0, void 0, function () {
            var _c, requestTimeoutInMs, abortError, path, queryString, port, method, url, body, xhr, raceOfPromises;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!!this.config) return [3, 2];
                        _c = this;
                        return [4, this.configProvider];
                    case 1:
                        _c.config = _d.sent();
                        _d.label = 2;
                    case 2:
                        requestTimeoutInMs = Number(this.config.requestTimeout) | 0;
                        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                            abortError = new Error("Request aborted");
                            abortError.name = "AbortError";
                            throw abortError;
                        }
                        path = request.path;
                        if (request.query) {
                            queryString = buildQueryString(request.query);
                            if (queryString) {
                                path += "?".concat(queryString);
                            }
                        }
                        port = request.port, method = request.method;
                        url = "".concat(request.protocol, "//").concat(request.hostname).concat(port ? ":".concat(port) : "").concat(path);
                        body = method === "GET" || method === "HEAD" ? undefined : request.body;
                        xhr = new XMLHttpRequest();
                        this.emit(EVENTS.XHR_INSTANTIATED, xhr);
                        raceOfPromises = [
                            new Promise(function (resolve, reject) {
                                var e_1, _a;
                                var streamCursor = 0;
                                var stream;
                                var writer;
                                xhr.upload.addEventListener("progress", function (event) {
                                    _this.emit(XhrHttpHandler.EVENTS.UPLOAD_PROGRESS, event, request);
                                });
                                xhr.addEventListener("progress", function (event) {
                                    _this.emit(XhrHttpHandler.EVENTS.PROGRESS, event, request);
                                });
                                xhr.addEventListener("error", reject);
                                xhr.addEventListener("timeout", function () {
                                    reject(new Error("XMLHttpRequest timed out."));
                                });
                                xhr.addEventListener("readystatechange", function () {
                                    var _a;
                                    var isArrayBuffer = xhr.responseType === "arraybuffer" && xhr.response;
                                    var isText = !isArrayBuffer && typeof xhr.responseText === "string";
                                    if (isText && !stream) {
                                        (_a = _this.initializeTransformStream(), stream = _a.stream, writer = _a.writer);
                                    }
                                    switch (xhr.readyState) {
                                        case XMLHttpRequest.LOADING:
                                            if (isText) {
                                                writer.write(streamCursor > 0 ? xhr.responseText.slice(streamCursor) : xhr.responseText);
                                                streamCursor = xhr.responseText.length;
                                            }
                                            break;
                                        case XMLHttpRequest.DONE:
                                            var body_1 = (function () {
                                                if (isArrayBuffer) {
                                                    return new Blob([xhr.response]);
                                                }
                                                if (isText) {
                                                    writer.releaseLock();
                                                    stream.writable.close();
                                                    return stream.readable;
                                                }
                                                reject(new Error("Unexpected XHR response type ".concat(xhr.responseType, ". Expected string or arraybuffer.")));
                                            })();
                                            resolve({
                                                response: new HttpResponse({
                                                    headers: _this.responseHeaders(xhr.getAllResponseHeaders()),
                                                    statusCode: xhr.status,
                                                    body: body_1,
                                                }),
                                            });
                                            break;
                                    }
                                });
                                xhr.open(method, url);
                                try {
                                    for (var _b = __values(Object.entries(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                        var _d = __read(_c.value, 2), header = _d[0], value = _d[1];
                                        if (!isForbiddenRequestHeader(header)) {
                                            xhr.setRequestHeader(header, value);
                                        }
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                                _this.emit(EVENTS.BEFORE_XHR_SEND, xhr);
                                xhr.send(body);
                            }),
                            requestTimeout(requestTimeoutInMs),
                        ];
                        if (abortSignal) {
                            raceOfPromises.push(new Promise(function (resolve, reject) {
                                abortSignal.onabort = function () {
                                    xhr.abort();
                                    var abortError = new Error("Request aborted");
                                    abortError.name = "AbortError";
                                    reject(abortError);
                                };
                            }));
                        }
                        return [2, Promise.race(raceOfPromises)];
                }
            });
        });
    };
    XhrHttpHandler.prototype.responseHeaders = function (xhrHeaders) {
        if (!xhrHeaders) {
            return {};
        }
        return xhrHeaders.split("\r\n").reduce(function (headerMap, line) {
            var parts = line.split(": ");
            var header = parts.shift();
            var value = parts.join(": ");
            headerMap[header] = value;
            return headerMap;
        }, {});
    };
    XhrHttpHandler.prototype.initializeTransformStream = function () {
        var textEncoder = new TextEncoder();
        var stream = new TransformStream({
            start: function () { },
            transform: function (chunk, controller) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        controller.enqueue(textEncoder.encode(String(chunk)));
                        return [2];
                    });
                });
            },
            flush: function () { },
        });
        var writer = stream.writable.getWriter();
        return {
            stream: stream,
            writer: writer,
        };
    };
    XhrHttpHandler.EVENTS = EVENTS;
    return XhrHttpHandler;
}(EventEmitter));
export { XhrHttpHandler };
var isForbiddenRequestHeader = function (header) {
    header = header.toLowerCase();
    if (header.startsWith("proxy-")) {
        return true;
    }
    if (header.startsWith("sec-")) {
        return true;
    }
    return forbiddenHeaders.includes(header);
};
var forbiddenHeaders = [
    "Accept-Charset",
    "Accept-Encoding",
    "Access-Control-Request-Headers",
    "Access-Control-Request-Method",
    "Connection",
    "Content-Length",
    "Cookie",
    "Date",
    "DNT",
    "Expect",
    "Feature-Policy",
    "Host",
    "Keep-Alive",
    "Origin",
    "Referer",
    "TE",
    "Trailer",
    "Transfer-Encoding",
    "Upgrade",
    "Via",
].map(function (_) { return _.toLowerCase(); });
